export default "__VITE_ASSET__95d64cb3__"